export const INFRA_STATUS = {
  RUNNING: "running",
  COMPLETED: "completed",
  FAILED: "failed",
};

export const POLLING_CONFIG = {
  INTERVAL: 30000, // 30 seconds
  MAX_ATTEMPTS: 20,
};

export const INFRA_TYPES = {
  AWS: "aws",
  AZURE: "azure",
  GCP: "gcp",
};
